import React from 'react';
import { BRAND_LIBRARY_LIGHT_TEXT_COLOR } from 'common/constants/brandLibrary';

import Block from 'common/components/TouchpointEditor/components/TouchpointNodes/Block';
import { StyledSessionsNavigationBlock } from './Block.styles';

export default function SessionsNavigationBlock(props) {
    return <StyledSessionsNavigationBlock {...props} id="viewAgenda" />;
}

SessionsNavigationBlock.splash = {
    ...Block.splash,
    defaultProps: {
        ...Block.splash.defaultProps,
        styles: {
            ...Block.splash.defaultProps.styles,
            backgroundColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
        },
    },
};
